// src/serviceWorkerRegistration.js
// This file is intentionally a no-op unless a real service worker exists.
export function register(config) {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    fetch(swUrl, { method: 'HEAD' })
      .then((response) => {
        if (response.ok) {
          navigator.serviceWorker.register(swUrl).then((registration) => {
            registration.onupdatefound = () => {
              const installingWorker = registration.installing;
              if (installingWorker == null) {
                return;
              }
              installingWorker.onstatechange = () => {
                if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  if (config && config.onUpdate) {
                    config.onUpdate(registration);
                  }
                }
              };
            };
          }).catch((error) => {
            console.warn('Service worker registration skipped:', error);
          });
        }
      })
      .catch(() => {
        // No service worker file is present, so skip registration silently.
      });
  });
}

export function unregister() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  navigator.serviceWorker.ready
    .then((registration) => {
      registration.unregister();
    })
    .catch((error) => {
      console.warn('Service worker unregister skipped:', error.message);
    });
}
